import React from 'react';
import { useNavigate } from 'react-router-dom';
import BackIcon from '../../../../assets/icons/icon_back.svg';

interface PostDetailsHeaderProps {
  canGoBack: boolean;
}

const PostDetailsHeader: React.FC<PostDetailsHeaderProps> = ({ canGoBack }) => {
  const navigate = useNavigate();
  
  return (
    <header className="post-details-header">
      {canGoBack && (
        <button onClick={() => navigate(-1)} className="back-button">
          <img src={BackIcon} alt="Back" className="back-icon" />
        </button>
      )}
      <h1>Playground</h1>
    </header>
  );
};

export default PostDetailsHeader; 